<template>
  <div>
    <router-link to="/" id="smallWrapper">
      <img id="smallLogo" src="../../../public/img/icons/ngc_bw.png" alt="logo" />
    </router-link>
    <div class="navbar">
      <router-link tag="a" to="/contact">Contact</router-link>
      <div class="dropdown">
        <router-link tag="a" to="/showroom">Showrooms</router-link>
      </div>
      <router-link tag="a" to="/">Home</router-link>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>

li {
  float: left;
  width: 100%;
  word-wrap: break-word;
  text-align: center;
}
#smallLogo {
  position: relative;
  width: 7.5%;
  float: left;
  top: 20px;
  left: 20px;
  max-width: 300px;
  z-index: 999999;
}

.navbar {
  position: absolute;
  width: 100%;
  overflow: hidden;
  background-color: #3f96c2;
  z-index: 9999;
}

.navbar a {
  position: relative;
  float: right;
  font-size: 18px;
  color: #f2f2f2;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
}

.dropdown {
  float: right;
  overflow: hidden;
  font-size: 20px;
}

.dropbtn {
  font-size: 18px;
}
.dropdown .dropbtn {
  border: none;
  outline: none;
  color: #f2f2f2;
  padding: 14px 16px;
  background-color: inherit;
  font-family: inherit;
  margin: 0;
}

.navbar a:hover,
.dropdown:hover .dropbtn {
  background-color: #4e606e;
  transition: 1s;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #4e606e;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  float: none;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}

.dropdown-content a:hover {
  background-color: #ddd;
  transition: 1s;
}

.dropdown:hover .dropdown-content {
  display: block;
  transition: 1s;
}

@media screen and (min-width: 1024px) {
  #hamNav {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  #smallLogo, #smallWrapper {
    display: none;
  }
}
</style>
